<div *ngIf="isLoading" class="overlay overlay-block cursor-default modal-body">
    <ng-container>
        <div class="overlay-layer bg-transparent">
            <div class="spinner spinner-lg spinner-success"></div>
        </div>
    </ng-container>
</div>

<div *ngIf="!isLoading" style="height: 100%;">

    <button mat-icon-button class="matdialog-close-btn" [mat-dialog-close]="true">
        <mat-icon class="close-icon">close</mat-icon>
    </button>

    <h1 mat-dialog-title>{{requesttype == 1 ? 'Angebotsanfrage' : 'Bestellung'}} prüfen und bestätigen</h1>
    <div matßdialogßcontent>

        <div class="content">

            <div>
                <div class="co_headline">Lieferadresse</div>

                <div class="co_row">
                    <mat-radio-group formControlName="addrType" required>
                        <mat-radio-button value="auto">Rechnungsadresse verwenden</mat-radio-button>
                        <mat-radio-button value="alt">Alternative
                            Lieferadresse:</mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="co_row">
                    <div class="col-6">
                        <div id="checkout_adr"></div>
                        <!-- {{rechnungAdr}} -->
                    </div>
                    <div class="col-6" *ngIf="firstFormGroup.value.addrType=='alt'">
                        <mat-form-field>
                            <mat-label>Name</mat-label>

                            <input matInput placeholder="Last name, First name" formControlName="firstCtrl" required>
                        </mat-form-field>
                    </div>

                </div>
            </div>

            <hr>

            <div>

                <div class="co_headline">Versandmethode</div>
                <div id="checkout_deliveryterm" class="co_row">Standard</div>

                <hr>

                <div class="co_headline">Zahlungsbedingung</div>
                <div id="checkout_paymentterm" class="co_row"></div>
                <!--<mat-form-field>
                    <mat-label>Zahlungsbedingung</mat-label>
                    
                    <input matInput id="checkout_paymentterm" formControlName="secondCtrl">
                </mat-form-field>-->

            </div>


            <div>
                <div class="checkout_footer_r">
                    <button id="btn_request" *ngIf="requesttype==1" color="accent" mat-raised-button mat-dialog-close="do_request">Angebot
                        anfragen</button>
                    <button id="btn_order" *ngIf="requesttype==2" color="accent" mat-raised-button mat-dialog-close="do_order">Bestellung
                        aufgeben</button>
                </div>
            </div>

        </div>
    </div>


</div>